import { Alert, Button, Card, CircularProgress } from '@mui/material';
import { Box, Stack, Typography } from './mui-system';
import type { FakesProgress } from '../../../api/src/fakes/fakes-matrix.types';
import { fakeDate } from './fakes-presentation';
import { sectionById } from '../api/generated/section-catalog';

export function FakesCollectionProgress({
  progress,
  error,
  changed,
  loading,
  onShow,
  onJobs,
  differentProfile,
}: {
  progress: FakesProgress | null;
  error: string;
  changed: boolean;
  loading: boolean;
  onShow(): void;
  onJobs(): void;
  differentProfile: boolean;
}) {
  const group = progress?.group;
  const processed = group ? group.complete + group.failed : 0;
  const percent = group?.total ? Math.floor((processed * 100) / group.total) : null;
  const color = group?.failed ? 'warning' : group?.pending ? 'primary' : 'success';
  return (
    <Card sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
        {percent !== null && (
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={percent}
              color={color}
              size={56}
              aria-label="Прогресс выбранной группы"
            />
            <Box sx={{ position: 'absolute', inset: 0, display: 'grid', placeItems: 'center' }}>
              <Typography fontSize={12}>{percent}%</Typography>
            </Box>
          </Box>
        )}
        <Box>
          <Typography fontWeight={700}>
            {!progress
              ? error
                ? 'Нет актуальных сведений'
                : 'Получаем прогресс…'
              : group?.total
                ? `Группа: обработано ${processed} из ${group.total}`
                : 'В группе нет запросов этого запуска'}
          </Typography>
          <Typography fontSize={13} color="text.secondary">
            {!progress
              ? ''
              : group
                ? group.pending
                  ? 'Сбор выполняется'
                  : group.failed
                    ? 'Завершено с ошибками'
                    : group.total
                      ? 'Сбор завершён'
                      : 'Нет данных'
                : 'Сбор ещё не запущен'}
            {group?.failed ? ` · ошибок: ${group.failed}` : ''}
            {progress?.run
              ? ` · весь сбор: ${progress.run.complete + progress.run.failed} из ${progress.run.total}`
              : ''}
          </Typography>
          {progress && (
            <Typography fontSize={12} color="text.secondary">
              Статус получен {fakeDate(progress.observedAt)}
              {error ? ' · данные устарели' : ''}
            </Typography>
          )}
        </Box>
        {changed && (
          <Button variant="contained" disabled={loading} onClick={onShow}>
            Показать новые данные
          </Button>
        )}
        <Button onClick={onJobs}>{sectionById('jobs').label}</Button>
      </Stack>
      {differentProfile && (
        <Typography mt={1} fontSize={13}>
          Активный сбор использует другой профиль. Показанная таблица относится к выбранному
          профилю.
        </Typography>
      )}
      {error && (
        <Alert severity="warning" sx={{ mt: 1 }}>
          Не удалось обновить прогресс: {error}
        </Alert>
      )}
    </Card>
  );
}
